import { BaseForm } from '@app/components/common/forms/BaseForm/BaseForm';
import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import { BaseSelect } from '@app/components/common/selects/BaseSelect/BaseSelect';
import { DropdownOption } from '@app/models/DropdownOption';
import { Row, Col, Form, Select, Radio, RadioChangeEvent } from 'antd';
import { useState } from 'react';

type RegularCustomerBusinessInfoProps = {
  isRegistered: boolean;
  accountTypes: DropdownOption[];
  company_types: DropdownOption[];
  mode: 'view' | 'edit';
};

export const RegularCustomerBusinessInfo: React.FC<RegularCustomerBusinessInfoProps> = (props) => {
  const form = Form.useFormInstance();
  const isRegisteredValue = Form.useWatch('is_registered', form);
  const registered = isRegisteredValue === true || isRegisteredValue === 'Yes';

  const readOnly = props.mode == 'view';
  const requiredMark = !readOnly;
  return (
    <>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={12} xl={8}>
          <BaseForm.Item name="business_type" label="Account Type" rules={[{ required: requiredMark }]}>
            {readOnly ? (
              <BaseInput readOnly={readOnly} />
            ) : (
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              <BaseSelect options={props.accountTypes} onChange={() => {}}></BaseSelect>
            )}
          </BaseForm.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={12} xl={8}>
          <BaseForm.Item name="business_name" label="Business Name" rules={[{ required: requiredMark }]}>
            <BaseInput readOnly={readOnly} />
          </BaseForm.Item>
        </Col>

        <Col xs={24} md={24} lg={12} xl={8}>
          <BaseForm.Item name="business_address" label="Business Address" rules={[{ required: requiredMark }]}>
            <BaseInput readOnly={readOnly} />
          </BaseForm.Item>
        </Col>

        <Col xs={24} md={24} lg={12} xl={8}>
          <BaseForm.Item name="company_type" label="Company Type" rules={[{ required: requiredMark }]}>
            {readOnly ? <BaseInput readOnly={readOnly} /> : <Select options={props.company_types}></Select>}
          </BaseForm.Item>
        </Col>
      </Row>

      <Row>
        <Col xs={24} md={24} lg={12} xl={8}>
          <BaseForm.Item name="is_registered" label="Business Registered?" rules={[{ required: requiredMark }]}>
            {readOnly ? (
              <BaseInput readOnly={readOnly} />
            ) : (
              <Radio.Group
                options={[
                  { label: 'Yes', value: true },
                  { label: 'No', value: false },
                ]}
              />
            )}
          </BaseForm.Item>
        </Col>
        {registered && (
          <Col xs={24} md={24} lg={12} xl={8}>
            <BaseForm.Item name="business_reg_no" label="Business Registration No" rules={[{ required: requiredMark }]}>
              <BaseInput readOnly={readOnly} />
            </BaseForm.Item>
          </Col>
        )}
      </Row>
    </>
  );
};
